import { isZendeskEnvProd } from "@/env/config";

// 年度ごとの健康診断お知らせURL（prod）
const healthCheckUrlsByFiscalYear: Record<number, string> = {
  2024: "https://help-top.mykenpo.com/hc/ja/articles/31937162595097",
  2025: "https://help-top.mykenpo.com/hc/ja/articles/43371447043993",
  2026: "https://help-top.mykenpo.com/hc/ja/articles/54059119700889",
};

// 年度ごとの契約外健診機関URL（prod）
const nonContractFacilityUrlsByFiscalYear: Record<number, string> = {
  2025: "https://help-members.mykenpo.com/hc/ja/articles/43371629862041",
  2026: "https://help-members.mykenpo.com/hc/ja/articles/54058694961305",
};

// デフォルトのURL（年度が不明な場合や該当しない場合）
const defaultHealthCheckUrl =
  "https://help-top.mykenpo.com/hc/ja/articles/54059119700889";

const membersZendeskHealthcheckUrls = {
  ["健康診断"]: {
    prod: defaultHealthCheckUrl,
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/11939200223375-2025%E5%B9%B4%E5%BA%A6%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E3%81%AE%E3%81%8A%E7%9F%A5%E3%82%89%E3%81%9B-%E5%8A%A0%E5%85%A5%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
  },
  ["補助金申請方法"]: {
    prod: "https://help-employers.mykenpo.com/hc/ja/articles/43371545258777",
    dev: "https://help-employers.dev.mykenpo.com/hc/ja/articles/11939241524623-2025%E5%B9%B4%E5%BA%A6%E3%81%AE%E5%81%A5%E8%A8%BA%E8%A3%9C%E5%8A%A9%E9%87%91%E3%81%AE%E6%94%AF%E7%B5%A6%E7%94%B3%E8%AB%8B%E6%96%B9%E6%B3%95-%E6%9D%B1%E6%8C%AF%E5%8D%94%E3%82%AA%E3%83%97%E3%82%B7%E3%83%A7%E3%83%B3%E6%A4%9C%E6%9F%BB%E3%82%92%E3%81%94%E5%88%A9%E7%94%A8%E6%99%82",
  },
  ["健康診断後の受診のお願い"]: {
    prod: "https://help-members.mykenpo.com/hc/ja/articles/31937708245273-%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E5%BE%8C%E3%81%AE%E5%8C%BB%E7%99%82%E6%A9%9F%E9%96%A2%E5%8F%97%E8%A8%BA%E3%81%AE%E3%81%8A%E9%A1%98%E3%81%84-%E5%8A%A0%E5%85%A5%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
    dev: "https://help-members.dev.mykenpo.com/hc/ja/articles/9656098592783-%E5%81%A5%E5%BA%B7%E8%A8%BA%E6%96%AD%E5%BE%8C%E3%81%AE%E5%8C%BB%E7%99%82%E6%A9%9F%E9%96%A2%E5%8F%97%E8%A8%BA%E3%81%AE%E3%81%8A%E9%A1%98%E3%81%84-%E5%8A%A0%E5%85%A5%E8%80%85%E3%81%AE%E7%9A%86%E6%A7%98%E3%81%B8",
  },
  ["ご自宅の近くに契約健診機関がない場合について"]: {
    prod: "https://help-members.mykenpo.com/hc/ja/articles/43371629862041",
    dev: "https://help-members.dev.mykenpo.com/hc/ja/articles/11939287045775",
  },
  ["健診制度の詳細なご案内"]: {
    prod: defaultHealthCheckUrl,
    dev: "https://help-top.dev.mykenpo.com/hc/ja/articles/11939200223375",
  },
} as const satisfies Record<string, { prod: string; dev: string }>;

export const getMembersZendeskHealthcheckUrl = (
  key: keyof typeof membersZendeskHealthcheckUrls,
  fiscalYear?: number,
) => {
  // 年度指定がある場合、年度ごとのURLを返す（prod環境のみ）
  if (fiscalYear != null && isZendeskEnvProd()) {
    if (key === "健康診断" || key === "健診制度の詳細なご案内") {
      return healthCheckUrlsByFiscalYear[fiscalYear] ?? defaultHealthCheckUrl;
    }
    if (key === "ご自宅の近くに契約健診機関がない場合について") {
      return (
        nonContractFacilityUrlsByFiscalYear[fiscalYear] ??
        membersZendeskHealthcheckUrls[key].prod
      );
    }
  }
  return membersZendeskHealthcheckUrls[key][
    isZendeskEnvProd() ? "prod" : "dev"
  ];
};
